/* eslint-disable max-len */
import { _, ts } from '_core';
// Do not change parent types. That is being used to get the alpha category for the analysis templates.
const P_TYPE = ts.enums.ALPHA_MODEL_PARENT_ENUM;

export const innerSubtypes = [
  { name: 'Custom', type: 'custom', parentType: P_TYPE.CUSTOM, disabled: false },
  {
    name: 'Ordinary Least Squares',
    type: 'linearRegression',
    parentType: P_TYPE.LINEAR_REGRESSION,
    disabled: false,
  },
  { name: 'Fixed Weights', type: 'fixed', parentType: P_TYPE.FIXED_WEIGHTS, disabled: false },
  {
    name: 'Gradient Boosting',
    type: 'gradientBoosting',
    parentType: P_TYPE.GRADIENT_BOOSTING,
    disabled: false,
  },
  { name: 'Lasso', type: 'lasso', parentType: P_TYPE.LINEAR_REGRESSION, disabled: false },
  {
    name: 'Optimized Model',
    type: 'optimizedModel',
    parentType: P_TYPE.OPTIMIZED_MODEL,
    disabled: false,
  },
  {
    name: 'Random Forest',
    type: 'randomForest',
    parentType: P_TYPE.RANDOM_FOREST,
    disabled: false,
  },
  {
    name: 'Robust Regression',
    type: 'robust',
    parentType: P_TYPE.LINEAR_REGRESSION,
    disabled: false,
  },
];

export const alphaParentTypes = [
  { name: 'Custom', type: P_TYPE.CUSTOM, disabled: false },
  { name: 'Fixed Weights', type: P_TYPE.FIXED_WEIGHTS, disabled: false },
  { name: 'Linear Model', type: P_TYPE.LINEAR_REGRESSION, disabled: false },
  { name: 'Optimized Model', type: P_TYPE.OPTIMIZED_MODEL, disabled: false },
  { name: 'Random Forest', type: P_TYPE.RANDOM_FOREST, disabled: false },
  { name: 'Gradient Boosting', type: P_TYPE.GRADIENT_BOOSTING, disabled: false },
];

export const types = _.uniq([...innerSubtypes.map((el) => el.type)]);
